// @ts-nocheck
/* eslint-disable */
(function() {
	/**
	 * signals:
	 * select-item { title, value }
	 * open
	 */
	class MapsSelect {
		constructor(items) {
			this._items = items;
			this._container = Mapy.Util.node("div", { className: "maps-select" });
			this._itemsEl = [];
			this._title = null;
			this._list = null;
			this._selected = null;

			this._build();
			document.body.addEventListener("click", this, false);
		}

		destroy() {
			this.close();

			this._title = null;
			this._list = null;
			this._selected = null;

			document.body.removeEventListener("click", this, false);
		}

		close() {
			this._list?.remove();
			this._container.classList.remove("open");
		}

		get container() {
			return this._container;
		}

		get value() {
			return this._selected;
		}

		handleEvent(e) {
			if (this._container.contains(e.target)) {
				if (e.target == this._title) {
					this._toggleShow();
				}
				else {
					let index = e.target.dataset.index;
					let item = this._items[index];

					this.close();

					if (this._selected == item) { return; }

					this._selected = item;
					this._title.innerHTML = item.title;

					const cEv = new CustomEvent("select-item", { detail: this._items[index] });
					this._container.dispatchEvent(cEv);
				}
			} else {
				this.close();
			}
		}

		_build() {
			let selected = Mapy.Util.node("p");
			let ul = Mapy.Util.node("ul");

			this._items.forEach((i, k) => {
				let item = Mapy.Util.node("li", {}, i.title);
				if (i.selected) {
					selected.innerHTML = i.title;
					this._selected = i;
				}

				item.setAttribute("data-index", k);

				this._itemsEl.push(item);

				ul.appendChild(item);
			});

			this._title = selected;
			this._list = ul;

			this._container.appendChild(selected);
		}

		_toggleShow() {
			if (this._list.parentNode) {
				this.close();
			} else {
				this._container.appendChild(this._list);
				this._container.classList.add("open");

				const cEv = new CustomEvent("open");
				this._container.dispatchEvent(cEv);
			}
		}
	}

	Mapy.MapsSelect = MapsSelect;
}());
